import { useFetchUserData } from 'src/Hooks/useFetchUserData'
import { User } from 'src/State/User/UserModel'
import { usePortalQuery } from 'src/Libs/api'

export const useInstallerData = (installerId?: number): [User | undefined, boolean] => {
  const { fetchUser } = useFetchUserData()

  const { data, isLoading } = usePortalQuery({
    queryKey: ['installer', installerId],
    queryFn: () => fetchUser(installerId!),
    enabled: !!installerId,
  })

  return [data ?? undefined, isLoading]
}
